<template>
  <div class="layer-rectangle-wrapper" :key="_uid">
    <div class="layer layer-1">
      <svg class="layer--img" viewBox="0 0 431 430" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M215.895 429.935C191.524 429.935 166.988 426.909 142.946 420.968C77.2046 404.629 26.2065 353.631 9.86736 287.889C-2.18072 239.476 -2.18072 190.404 9.86736 142.046C26.2065 76.3045 77.2046 25.3065 142.946 8.96729C166.933 3.02577 191.469 0 215.895 0C240.266 0 264.803 3.02577 288.844 8.96729C354.586 25.3065 405.584 76.3045 421.923 142.046C433.971 190.459 433.971 239.531 421.923 287.889C405.584 353.631 354.586 404.629 288.844 420.968C264.803 426.909 240.266 429.935 215.895 429.935ZM215.895 16.3942C192.844 16.3942 169.628 19.2549 146.962 24.9214C87.1621 39.7752 40.7853 86.1521 25.8765 146.007C14.4886 191.779 14.4886 238.156 25.8765 283.928C40.7303 343.728 87.1071 390.105 146.962 405.014C169.683 410.68 192.844 413.541 215.895 413.541C238.946 413.541 262.162 410.68 284.828 405.014C344.628 390.16 391.005 343.783 405.914 283.928C417.302 238.156 417.302 191.779 405.914 146.007C391.06 86.2071 344.683 39.8302 284.828 24.9214C262.107 19.2549 238.891 16.3942 215.895 16.3942Z"
            fill="#37B1F8"
        />
      </svg>

    </div>
    <div class="layer layer-2">
      <svg class="layer--img" viewBox="0 0 356 356" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M177.895 355.195C156.77 355.195 135.479 352.554 114.629 347.383C62.1454 334.345 21.435 293.634 8.39663 241.151C-2.05604 199.175 -2.05604 156.649 8.39663 114.674C21.435 62.1901 62.1454 21.4797 114.629 8.44137C135.479 3.27004 156.77 0.629395 177.895 0.629395C199.02 0.629395 220.311 3.27004 241.161 8.44137C293.645 21.4797 334.355 62.1901 347.393 114.674C357.846 156.649 357.846 199.23 347.393 241.151C334.355 293.634 293.645 334.345 241.161 347.383C220.256 352.609 199.02 355.195 177.895 355.195ZM177.895 16.6935C158.09 16.6935 138.065 19.1691 118.535 24.0104C71.8279 35.6183 35.6286 71.8176 24.0206 118.525C14.2281 157.915 14.2281 197.855 24.0206 237.3C35.6286 284.007 71.8279 320.206 118.535 331.814C138.12 336.655 158.09 339.131 177.895 339.131C197.7 339.131 217.725 336.655 237.255 331.814C283.962 320.206 320.161 284.007 331.769 237.3C341.562 197.91 341.562 157.915 331.769 118.525C320.161 71.8176 283.962 35.6183 237.255 24.0104C217.67 19.1691 197.7 16.6935 177.895 16.6935Z"
            fill="#1EACFF"
        />
      </svg>
    </div>
    <div class="layer layer-3">
      <div class="view" :class="{ 'visible-overflow': visibleOverflow }">
        <slot />
      </div>
      <svg
        class="layer--img"
        width="280"
        height="280"
        viewBox="0 0 280 280"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M139.895 279.456C122.015 279.456 104.026 277.255 86.3111 272.854C47.0861 263.117 16.7183 232.694 6.98084 193.524C-1.87643 157.985 -1.87643 121.951 6.98084 86.4115C16.7183 47.1865 47.1411 16.8187 86.3111 7.08118C103.971 2.68006 122.015 0.479492 139.895 0.479492C157.774 0.479492 175.764 2.68006 193.479 7.08118C232.704 16.8187 263.071 47.2415 272.809 86.4115C281.666 121.951 281.666 157.985 272.809 193.524C263.071 232.749 232.649 263.117 193.479 272.854C175.764 277.255 157.719 279.456 139.895 279.456ZM139.895 15.9935C123.281 15.9935 106.556 18.084 90.1071 22.155C56.5485 30.5172 30.4718 56.5388 22.1097 90.1524C13.9126 123.216 13.9126 156.719 22.1097 189.783C30.4718 223.342 56.4935 249.418 90.1071 257.78C106.556 261.851 123.281 263.942 139.895 263.942C156.509 263.942 173.233 261.851 189.683 257.78C223.241 249.418 249.318 223.397 257.68 189.783C265.877 156.719 265.877 123.216 257.68 90.1524C249.318 56.5939 223.296 30.5172 189.683 22.155C173.233 18.084 156.454 15.9935 139.895 15.9935Z"
          fill="#1EACFF"
        />
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      visibleOverflow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {};
    }
  };
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  .layer-rectangle-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    @include respond-to(tabletRotate) {
      position: static;
    }
  }
  .layer {
    position: absolute;
    width: 100%;
    height: 100%;
    &--img {
      //position: absolute;
      //width: 100%;
      //height: 100%;
      //animation: pulse 2s infinite ease-in-out;
      //-webkit-animation: pulse 2s infinite ease-in-out;
      //pointer-events: none;
    }

    &-1 {
      .layer--img {
        //animation-delay: 0.3s;
      }
    }

    &-2 {
      top: 9%;
      left: 9%;
      width: 82%;
      height: 82%;
    }

    &-3 {
      top: 17%;
      left: 17%;
      width: 66%;
      height: 66%;
      svg {
        width: 100%;
        height: 100%;
        pointer-events: none;
      }
    }
  }

  .view {
    position: absolute;
    top: 0.5%;
    left: 0.5%;
    width: 99%;
    height: 99%;
    border-radius: 50%;
    overflow: hidden;
    &.visible-overflow {
      overflow: visible;
    }
  }

  //@keyframes pulse {
  //  from {
  //    //transform: none;
  //  }
  //
  //  50% {
  //    -webkit-transform: scale(1.05, 1.05);
  //    transform: scale(1.05, 1.05);
  //  }
  //  to {
  //    //transform: none;
  //  }
  //}
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/slideComponents/CircleWrapper.vue